import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {Divider, Skeleton} from "@mui/material";
import {
  CardActionsStyles,
  CardContentStyles,
  ContentTitleDividerStyles,
  StyledCard,
  StyledNavLink,
} from "./styles";
import { ContentItem } from "../../../sanity/types";
import { getContentPath } from "../../../sanity/paths";

interface Props {
  content: ContentItem;
}

export const GeneralContentCardSkeleton = () => (
  <StyledCard variant="outlined">
    <CardContent sx={CardContentStyles}>
      <Skeleton variant="text" width="80%" height={28} sx={{mx: "auto"}} />
      <Divider sx={ContentTitleDividerStyles} />
      <Skeleton variant="text" width="90%" height={18} sx={{mt: 2}} />
      <Skeleton variant="text" width="70%" height={18} />
    </CardContent>
    <Divider />
    <CardActions sx={CardActionsStyles}>
      <Skeleton variant="rectangular" width={80} height={24} />
    </CardActions>
  </StyledCard>
);

export default function GeneralContentCard({ content }: Props) {
  const description = content.excerpt || content.bodyText;
  const detailPath = getContentPath(content.category, content.slug);
  const truncateLength = 80;

  return (
    <StyledCard variant="outlined">
      <CardContent sx={CardContentStyles}>
        <Typography
          color="text.primary"
          variant="body1"
          gutterBottom
          fontWeight="bold"
          textAlign={"center"}
          marginBottom={"15px"}
        >
          {content.title}
        </Typography>
        <Divider sx={ContentTitleDividerStyles} />

        {description && (
          <Typography variant="body2" color="text.secondary" marginTop={"15px"}>
            {description.length > truncateLength
              ? description.substring(0, truncateLength) + "..."
              : description}
          </Typography>
        )}
      </CardContent>
      {detailPath && (
        <>
          <Divider />

          <CardActions sx={CardActionsStyles}>
            <StyledNavLink to={detailPath}>READ MORE</StyledNavLink>
          </CardActions>
        </>
      )}
    </StyledCard>
  );
}
